import { useMutation, useQueryClient } from '@tanstack/react-query';
import { carrierExclusionListKey } from '../lib/queryKeys';

export interface UseRemoveExcludedUser {
  remove: (userId: number) => void;
  isRemoving: boolean;
  isError: boolean;
  hasRemoved: boolean;
}

// Same contract as the add: awaits the carrier's invalidation so the row is gone before the button
// idles, invalidates on failure too, and never retries a refused write.
export function useRemoveExcludedUser(
  slug: string,
  removeExcludedUser: (slug: string, userId: number) => Promise<void>,
): UseRemoveExcludedUser {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    retry: false,
    mutationFn: async (userId: number): Promise<void> => {
      await removeExcludedUser(slug, userId);
      await queryClient.invalidateQueries({ queryKey: carrierExclusionListKey(slug) });
    },
    onError: () => {
      void queryClient.invalidateQueries({ queryKey: carrierExclusionListKey(slug) });
    },
  });

  return {
    remove: (userId) => {
      mutation.mutate(userId);
    },
    isRemoving: mutation.isPending,
    isError: mutation.isError,
    hasRemoved: mutation.isSuccess,
  };
}
